import ErpHero from "../../components/erp/ErpHero/ErpHero";
import TrustBar from "../../components/erp/TrustBar/TrustBar";
import ZatcaCompliance from "../../components/erp/ZatcaCompliance/ZatcaCompliance";
import ErpModules from "../../components/erp/ErpModules/ErpModules";
import ErpFeatures from "../../components/erp/ErpFeatures/ErpFeatures";
import WhyLiteSoft from "../../components/erp/WhyLiteSoft/WhyLiteSoft";
import HowWeStart from "../../components/erp/HowWeStart/HowWeStart";
import Sectors from "../../components/erp/Sectors/Sectors";
import Faq from "../../components/erp/Faq/Faq";
import ErpCta from "../../components/erp/ErpCta/ErpCta";
import ErpWhatsAppFloat from "../../components/erp/ErpWhatsAppFloat/ErpWhatsAppFloat";
import Contact from "../../components/Contact/Contact";
import PageSeo from "../../components/seo/PageSeo";
import JsonLd from "../../components/seo/JsonLd";
import {
  erpSeo,
  organizationLd,
  softwareApplicationLd,
  faqPageLd,
} from "../../seo/seoConfig";
import "./ErpLanding.css";

function ErpLanding() {
  return (
    <div className="erp-landing">
      <PageSeo
        title={erpSeo.title}
        description={erpSeo.description}
        path={erpSeo.path}
      />
      <JsonLd data={[organizationLd, softwareApplicationLd, faqPageLd]} />
      <ErpHero />
      <TrustBar />
      <ZatcaCompliance />
      <ErpModules />
      <ErpFeatures />
      <WhyLiteSoft />
      <HowWeStart />
      <Sectors />
      <Faq />
      <ErpCta />
      <Contact />
      <ErpWhatsAppFloat />
    </div>
  );
}

export default ErpLanding;
